import StarBurst from './StarBurst';

export default class CharacterSlotSeek extends Phaser.Group {
  constructor(game, characterId) {
    super(game);

    this.characterId = characterId;

    this.hidden = this.game.make.image(0, 0, 'ui_character_icons', this.characterId + '_seek');
    this.hidden.anchor.set(0.5);
    this.addChild(this.hidden);
    this.found = this.game.make.image(0, 0, 'ui_character_icons', this.characterId + '_found');
    this.found.anchor.set(0.5);
    this.addChild(this.found);

    this.found.visible = false;
    this.isGoingUp = false;

    //
    this.hidden.inputEnabled = true;
    this.hidden.input.useHandCursor = true;
    this.hidden.events.onInputOver.add(this.handleInputOver, this);
    this.hidden.events.onInputOut.add(this.handleInputOut, this);
    this.hidden.events.onInputDown.add(this.handleInputDown, this);
  }

  handleInputDown() {
    this.game.state.getCurrentState().showClue(this.characterId);
    if (!this.game.device.desktop) {
      this.handleInputOut();
    }
  }

  handleInputOver() {
    this.scale.set(1.1);
  }

  handleInputOut() {
    this.scale.set(1);
  }

  lock() {
    // console.log('lock', this.characterId);
    // this.hidden.input.enabled = false;
    // this.hidden.input.useHandCursor = false;
    this.hidden.events.onInputDown.remove(this.handleInputDown, this);
    // this.hidden.events.onInputOver.remove(this.handleInputOver, this);
    // this.hidden.events.onInputOut.remove(this.handleInputOut, this);
    // this.hidden.events.onInputUp.remove(this.handleInputOut, this);
  }

  unlock() {
    // console.log('unlock', this.characterId);
    // this.hidden.input.enabled = true;

    // this.hidden.input.useHandCursor = true;
    this.hidden.events.onInputDown.add(this.handleInputDown, this);
    // this.hidden.events.onInputOver.add(this.handleInputOver, this);
    // this.hidden.events.onInputOut.add(this.handleInputOut, this);
    // this.hidden.events.onInputUp.add(this.handleInputOut, this);
  }

  revealCharacter() {
    this.stopPulse();
    this.scale.set(1);
    this.hidden.visible = false;
    this.found.visible = true;

    this.game.add
      .tween(this.scale)
      .to({ x: [1.2, 1], y: [1.2, 1] }, 400, Phaser.Easing.Back.Out, true)
      .onComplete.add(this.goUp, this);

    //
    this.starBurst = new StarBurst(this.game);
    this.addChild(this.starBurst);
  }

  goUp() {
    this.game.add.tween(this).to({ y: -200 }, 300, Phaser.Easing.Back.In, true, 200);
    this.isGoingUp = true;
  }

  enlarge() {
    this.stopPulse();
    this.game.add.tween(this.scale).to({ x: 1.2, y: 1.2 }, 200, Phaser.Easing.Back.Out, true);
  }

  normalize() {
    this.stopPulse();
    this.game.add.tween(this.scale).to({ x: 1, y: 1 }, 200, Phaser.Easing.Back.Out, true);
  }

  pulse(repeat) {
    this.pulseTween = this.game.add
      .tween(this.scale)
      .to({ x: [1.2, 1], y: [1.2, 1] }, 800, Phaser.Easing.BackOut, true, 0, repeat);
  }

  stopPulse() {
    if (this.pulseTween) {
      this.pulseTween.stop();
      this.pulseTween = false;
    }
  }

  update() {
    if (this.x !== this.destX && !this.isGoingUp) {
      this.x += (this.destX - this.x) * 0.2;
    }
    super.update();
  }

  destroy() {
    this.stopPulse();
    this.hidden.destroy();
    this.found.destroy();
    this.hidden = null;
    this.found = null;
    super.destroy();
  }
}
